import React from 'react';
import styles from '../../app.module.css';

const HeadersList = ({ headers, onEdit, onDelete, editingHeaderName, tempHeader, setTempHeader, handleSave, handleCancel }) => {
    return (
        <div>
            {Object.entries(headers).map(([name, header]) => (
                <div key={name} className={styles.mainContainer}>
                    {editingHeaderName === name ? (
                        <>
                            <label>Name:</label>
                            <input
                                type="text"
                                value={tempHeader.name}
                                disabled
                                className={styles.textBox}
                            />

                            <label>Description:</label>
                            <textarea
                                value={tempHeader.description}
                                onChange={(e) => setTempHeader({ ...tempHeader, description: e.target.value })}
                                className={styles.textBox}
                            />

                            <label>Type:</label>
                            <select
                                value={tempHeader.schema.type}
                                onChange={(e) => setTempHeader({
                                    ...tempHeader,
                                    schema: { ...tempHeader.schema, type: e.target.value }
                                })}
                                className={styles.textBox}
                            >
                                <option value="">Select Type</option>
                                <option value="string">String</option>
                                <option value="integer">Integer</option>
                                <option value="boolean">Boolean</option>
                                <option value="array">Array</option>
                                <option value="object">Object</option>
                            </select>

                            <label>
                                Required:
                                <input
                                    type="checkbox"
                                    checked={tempHeader.required}
                                    onChange={(e) => setTempHeader({ ...tempHeader, required: e.target.checked })}
                                />
                            </label>

                            <div className={styles.sNcButtonContainer}>
                                <button className={styles.saveButton} onClick={handleSave}>
                                    Save
                                </button>
                                <button className={styles.cancelButton} onClick={handleCancel}>
                                    Cancel
                                </button>
                            </div>
                        </>
                    ) : (
                        <>
                            <p><strong>Name:</strong> {name}</p>
                            <p><strong>Type:</strong> {header.schema?.type || 'N/A'}</p>
                            <p><strong>Description:</strong> {header.description || 'No description'}</p>
                            <p><strong>Required:</strong> {header.required ? 'Yes' : 'No'}</p>
                            <div className={styles.actionButtonsContainer}>
                                <button className={styles.editButton} onClick={() => onEdit(name)}> Edit </button>
                                <button className={styles.deleteButton} onClick={() => onDelete(name)}> Delete </button>
                            </div>
                        </>
                    )}
                </div>
            ))}
        </div>
    );
};

export default HeadersList;
